import React, {useContext, useState} from 'react';
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Input from "@amzn/meridian/input";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import {FormattedMessage, injectIntl} from "react-intl";
import Column from "@meridian/components/column";
import Text from "@amzn/meridian/text";
import Alert from "@amzn/meridian/alert"
import {
    checkModalValidationsForTestPackage, isValidEntry, PATTERNS
} from "../../../util/Validations";
import {DraftContext} from "../../../draftSave/context/DraftSaveContext";
import {CONFIG_TYPE} from "../../../util/Constants";
import {getTestConfigKey} from "../../../util/Util";

const AddAdtfSorterTestPackageModal = (props) => {

    const {formatMessage} = props.intl;
    const {mac} = props;
    const {getDraftData, addInstance, editInstance} = useContext(DraftContext);

    // Visual controls
    const {open, setOpen} = props;
    const [show, setShow] = useState(false);
    const [edit, setEdit] = useState(false);

    // Values
    const [scannables, setScannables] = useState("");
    const [sortZone, setSortZone] = useState("");

    // Error
    const [scannablesErr, setScannablesErr] = useState(false);
    const [sortZoneErr, setSortZoneErr] = useState(false);

    function onCloseModal() {
        setShow(false);
        setOpen(false);
        resetInputState();
    }

    const sorterTestPackage = {
        scannables: scannables.split(';').filter(Boolean),
        sortZone: sortZone
    }

    const testConfigMap = {}
    getDraftData({stateKey: CONFIG_TYPE.ADTF_SORTER_TEST_PACKAGE, subKey: mac}).forEach((value) => {
        const key = getTestConfigKey(value.scannables);
        testConfigMap[key] = {
            sortZone: value.sortZone
        };
    })

    const onClickConfirm = (sorterTestPackage, mac) => {
        if (checkModalValidationsForTestPackage(sorterTestPackage)) {
            setConfigData(sorterTestPackage, mac);
            setOpen(false);
            resetInputState();
            setShow(false);
        } else {
            setShow(true);
        }
    }

    const prefill = () => {
        const key = getTestConfigKey(sorterTestPackage.scannables);
        if (testConfigMap.hasOwnProperty(key)) {
            setEdit(true);
            resetConfigErrorDetails();
            setSortZone(testConfigMap[key].sortZone);
        } else if (edit) {
            setEdit(false);
            resetConfigDetails()
        }
    }

    function resetInputState() {
        setScannables("");
        resetConfigDetails();
        resetConfigErrorDetails();
    }

    const resetConfigDetails = () => {
        setSortZone("");
    }

    const resetConfigErrorDetails = () => {
        setSortZoneErr(false);
    }

    const setConfigData = (sorterTestPackage, mac) => {
        if(edit) {
            editInstance({
                stateKey: CONFIG_TYPE.ADTF_SORTER_TEST_PACKAGE,
                subKey: mac,
                instance: sorterTestPackage,
                keyComparator: (config1, config2) => (
                    getTestConfigKey(config1.scannables) === getTestConfigKey(config2.scannables)
                ),
                valueComparator: (config1, config2) => {
                    return config1.sortZone === config2.sortZone;
                }
            });
        } else {
            addInstance({
                stateKey: CONFIG_TYPE.ADTF_SORTER_TEST_PACKAGE,
                subKey: mac,
                instance: sorterTestPackage
            });
        }
    }

    return (
        <Row>
            <Modal
                title={formatMessage({id: "sortertestconfig.addupdatetest"})}
                open={open}
                onClose={onCloseModal}
                scrollContainer="viewport"
                closeLabel="Close"
                bodySpacingInset="medium">
                <Column spacing={"medium"} spacingInset={"medium"}>
                    <Column spacing="200">
                        <b> <FormattedMessage id="modal.addheadingtest"
                                              defaultMessage="To edit an existing configuration, enter its Sort Zone."/>
                        </b>
                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            <FormattedMessage id="bay.scannables" defaultMessage="Scannables"/>
                        </Text>
                        <Input id="scannables-input"
                               value={scannables}
                               onChange={(value) => {setScannables(value.replace(/\s/g, ''))}}
                               onBlur={() => {
                                   setScannablesErr(!isValidEntry(scannables, PATTERNS.TEST_SCANNABLE));
                                   prefill();
                               }}
                               error={scannablesErr}
                               helperText={<FormattedMessage id="bay.scannables_description"
                                 defaultMessage="Tracking/Shipment ID. Separate multiple values by semicolon (;)"/>}/>
                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            <FormattedMessage id="bay.sortzone"
                                              defaultMessage="Sort Zone"/>
                        </Text>
                        <Input id="sort-zone-input"
                               value={sortZone}
                               onChange={setSortZone}
                               onBlur={() => {setSortZoneErr(!isValidEntry(sortZone, PATTERNS.SORT_ZONE))}}
                               error={sortZoneErr}
                               helperText={<FormattedMessage id="bay.sortzone_description"
                                         defaultMessage="eg. EU: A1-1A, NA: A-1.1A"/> }/>
                    </Column>
                </Column>
                <ModalFooter>
                    <Column>
                        {!checkModalValidationsForTestPackage(sorterTestPackage) &&
                            show &&
                            <Alert type="warning" size="small">
                                <FormattedMessage id="alert.missingfields"
                                                  defaultMessage="Please enter all fields in correct format!"/>
                            </Alert>}
                    </Column>
                    <Row alignmentHorizontal="right" widths="fit">
                        <Button type="secondary" size="medium" onClick={onCloseModal}>
                            <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
                        </Button>
                        <Button type="primary" size="medium"
                                onClick={() => onClickConfirm(sorterTestPackage, mac)}>
                            { edit ? <FormattedMessage id="modal.confirmUpdate" defaultMessage="Confirm update"/>
                                : <FormattedMessage id="modal.confirmAdd" defaultMessage="Confirm add"/>}
                        </Button>
                    </Row>
                </ModalFooter>
            </Modal>
        </Row>
    )
}

export default injectIntl(AddAdtfSorterTestPackageModal);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtfdevice/modal/AddAdtfSorterTestPackageModal.js